<template>
    <div
        class="flex flex-wrap"
        :class="[loading ? 'opacity-50' : 'opacity-100']"
    >
        <div class="w-full md:w-1/2 p-2">
            <FormKit
                type="text"
                label="Initial Learning Plan Fall Year"
                v-model="form.initial_learning_plan_fall_year"
                validation="required|string"
                validation-visibility="submit"
                :classes="formElement"
            />
            <p
                class="text-red-500 text-sm font-semibold mt-1"
                v-if="validationErrors?.initial_learning_plan_fall_year"
            >
                {{ validationErrors.initial_learning_plan_fall_year }}
            </p>
        </div>
        <div class="w-full md:w-1/2 p-2">
            <FormKit
                type="text"
                label="Final Learning Plan Fall Year"
                v-model="form.final_learning_plan_fall_year"
                validation="required|string"
                validation-visibility="submit"
                :classes="formElement"
            />
            <p
                class="text-red-500 text-sm font-semibold mt-1"
                v-if="validationErrors?.final_learning_plan_fall_year"
            >
                {{ validationErrors.final_learning_plan_fall_year }}
            </p>
        </div>
        <div class="w-full md:w-1/2 p-2">
            <FormKit
                type="text"
                label="Final Learning Plan Spring Year"
                v-model="form.final_learning_plan_spring_year"
                validation="required|string"
                validation-visibility="submit"
                :classes="formElement"
            />
            <p
                class="text-red-500 text-sm font-semibold mt-1"
                v-if="validationErrors?.final_learning_plan_spring_year"
            >
                {{ validationErrors.final_learning_plan_spring_year }}
            </p>
        </div>
    </div>
    <div class="flex justify-end" v-if="configuration?.modified">
        <p class="px-2 text-sm text-gray-500 mt-4">
            Updated {{ configuration.modified }}
        </p>
    </div>
    <Teleport to="#slp" v-if="mounted">
        <button
            type="submit"
            class="btn btn-primary"
            :class="[loading ? 'opacity-50' : 'opacity-100']"
            :disabled="loading"
            @click="submit"
        >
            {{ loading ? "Updating..." : "Update" }}
        </button>
    </Teleport>
</template>

<script setup>
import { onMounted, onUnmounted, ref, reactive } from "vue";
import { useFormStyles } from "@/composables/styles";
import { Inertia } from "@inertiajs/inertia";
import { useAlert } from "@/composables/alert.js";

const props = defineProps({
    configuration: {
        type: Object,
        required: true,
    },
});

const mounted = ref(false);
const loading = ref(false);
const validationErrors = ref(null);
const { showAlert } = useAlert();

onMounted(() => (mounted.value = true));
onUnmounted(() => (mounted.value = false));

const { formElement } = useFormStyles();

const form = reactive({
    ...props.configuration,
});

async function submit() {
    loading.value = true;

    Inertia.post(route("configuration.slp.update"), form, {
        onSuccess: () => {
            showAlert("Changes saved!", {
                icon: "success",
                toast: true,
                position: "top-end",
                showConfirmButton: false,
            });
        },
        onError: (errors) => {
            validationErrors.value = errors;
        },
        onFinish: () => (loading.value = false),
    });
}
</script>
